import hamburger from "./modules/hamburger";
import brandsSlider from "./modules/brandsSlider";
import countriesSwitcher from "./modules/countriesSwitcher";
import numbersSection from './modules/numbersSection';
import opinionSlider from './modules/opinionSliders';
import wholesalers from './modules/wholesalers';
import usersSliders from "./modules/usersImages";
import orderSteps from "./modules/orderSteps";
import phoneSlider from "./modules/phoneSlider";
import toTop from "./modules/toTop";
import ageGate from "./modules/ageGate";
import aos from "./modules/aos";
import header from "./modules/header";
import countrySwitcher from "./modules/countrySwitcher";
import { Collapse } from 'bootstrap';

var documentReady = function () {
    hamburger();
    brandsSlider();
    countriesSwitcher();
    numbersSection();
    opinionSlider();
    wholesalers();
    usersSliders();
    orderSteps();
    phoneSlider();
    toTop();
    ageGate();
    aos();
    header();
    countrySwitcher();
};

if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
    documentReady();
} else {
    document.addEventListener("DOMContentLoaded", documentReady);
}
